export const CARD_WIDTH = 300;

export const CARD_HEIGHT = 300;

export const ListViewType = {
  BigPreview: 0,
  Columns: 1,
};
